module.exports = __webpack_public_path__ + "static/media/KinoLogoDarkBG.ca5c7c58.svg";